import { ListIcones } from './icones';

export enum ColorNames {
  Primary = '#007bff',
  PrimaryLight = '#2196f3',
  Secondary = '#6c757d',
  Success = '#28a745',
  Danger = '#dc3545',
  Warning = '#ffc107',
  Info = '#17a2b8',
}

export interface Icons {
  icon?: {
    name: ListIcones;
    color?: ColorNames;
  };
  route?: string;
  text?: string;
  subtitle?: string;
}
